import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

type Breakpoint =
    | "xs"
    | "sm"
    | "md"
    | "lg"
    | "xl";

export const useResponsive = () => {
    const theme = useTheme();

    // Individual breakpoint matches
    const xs = useMediaQuery(theme.breakpoints.only("xs"));
    const sm = useMediaQuery(theme.breakpoints.only("sm"));
    const md = useMediaQuery(theme.breakpoints.only("md"));
    const lg = useMediaQuery(theme.breakpoints.only("lg"));
    const xl = useMediaQuery(theme.breakpoints.only("xl"));

    // Down helpers
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));   // <600
    const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // 600–900
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));    // ≥900

    // Up helpers
    const smUp = useMediaQuery(theme.breakpoints.up("sm"));
    const mdUp = useMediaQuery(theme.breakpoints.up("md"));
    const lgUp = useMediaQuery(theme.breakpoints.up("lg"));

    // Down helpers
    const smDown = useMediaQuery(theme.breakpoints.down("sm"));
    const mdDown = useMediaQuery(theme.breakpoints.down("md"));
    const lgDown = useMediaQuery(theme.breakpoints.down("lg"));

    // Get current active breakpoint
    const getBreakpoint = (): Breakpoint => {
        if (xl) return "xl";
        if (lg) return "lg";
        if (md) return "md";
        if (sm) return "sm";
        return "xs";
    };

    return {
        // exact
        xs,
        sm,
        md,
        lg,
        xl,

        // grouped
        isMobile,
        isTablet,
        isDesktop,

        // up
        smUp,
        mdUp,
        lgUp,

        // down
        smDown,
        mdDown,
        lgDown,

        currentBreakpoint: getBreakpoint(),
    };
};